// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"addea741","930":"d8be7bc2"}[chunkId] + ".chunk.js";
};